import { render, staticRenderFns } from "./website.vue?vue&type=template&id=da98cd9c&"
import script from "./website.vue?vue&type=script&lang=js&"
export * from "./website.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports